import { LocalizedMessage } from '@services/requests/localizedMessagesService/interfaces';
import { Filter } from '@services/types';
import { GraphQLQuery } from '@settings/services/graphQLClient/GraphQLClient';
import gql from 'graphql-tag';

interface WhereParams {
  default_name?: Filter<string>;
  id?: Filter<string>;
  _or?: WhereParams[];
  _and?: WhereParams[];
}

/**
 * Параметры для получения данных упаковок экосбора по фильтрам
 */
export interface EcoFeePackagesLoaderParams {
  limit?: number;
  offset?: number;
  where?: WhereParams;
}

export interface EcoFeePackagesLoaderResponse {
  items: {
    id: string;
    default_name: string;
    group_id: string;
    localized_names: string[];
    localized_names_data: LocalizedMessage[];
    group: {
      group_type: 'packages' | 'products';
      id: string;
      name: string;
      number_group: string;
      rate_value: number;
      normative_value: number;
      coefficient: number;
    };
  }[];
}

/**
 * Запрос загрузки данных упаковок экосбора
 */
export class EcoFeePackagesLoaderQuery implements GraphQLQuery<EcoFeePackagesLoaderParams> {
  readonly query: any;

  readonly variables: EcoFeePackagesLoaderParams;

  constructor(params: EcoFeePackagesLoaderParams) {
    this.variables = {
      ...params,
    };
    this.query = gql`
      query EcoFeePackagesLoader(
        $limit: Int = 60
        $offset: Int = 0
        $where: packages_gql_query_where_object
      ) {
        items: packages_gql_list(
          limit: $limit
          offset: $offset
          where: $where
          order: [{ by: id, direction: desc, priority: 1 }]
        ) {
          id
          default_name
          group_id
          localized_names
          group {
            group_type
            id
            name
            number_group
            coefficient
            normative_value
            rate_value
          }
        }
      }
    `;
  }
}
